module.exports = __webpack_public_path__ + "static/media/kudos-celebration-new.f125380f.gif";